import { IconField } from "primereact/iconfield"
import { InputIcon } from "primereact/inputicon"
import { InputText } from "primereact/inputtext"

export function InputFilter({ filterText, onFilterTextChange, placeholder }) {
    return (
        <div className='w-full'>
            <IconField iconPosition="left" className='m-0 p-0'>
                <InputIcon className="pi pi-search"> </InputIcon>
                <InputText value={filterText} onChange={(e) => onFilterTextChange(e.target.value)} placeholder={placeholder} className='w-full' />
            </IconField>
        </div>
    )
}